import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/perfil',
    name: 'perfil',
    component: () => import('./views/PerfilView.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      breadcrumb: 'Mi perfil',
    },
  },
]

export default routes
